import {
  AppWindow,
  ExternalLinkIcon,
  Eye,
} from "lucide-react";
import React from "react";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "../../components/ui/dialog";
import { ProductCarousel } from "../../components/productImageCarousel";
import { wooProduct } from "./productInterface";
import { Link, useNavigate } from "react-router-dom";
import AddToCart from "../../components/addToCart";

export default function ProductPreview({
  product,
}: {
  product: wooProduct;
}) {
  const nav = useNavigate();
  const [mainImgSrc, setMainImgSrc] = React.useState("");
  const setImageOnClick = (src: string) => {
    setMainImgSrc(src);
  };
  return (
    <Dialog>
      <DialogTrigger asChild className="lg:block hidden">
        <Eye className="size-5 stroke-1 cursor-pointer dark:text-neutral-900" />
      </DialogTrigger>
      <DialogContent className="max-w-full w-1/2">
        <div className="flex gap-5 w-full">
          <div className=" w-full flex flex-col justify-between items-center gap-5">
            <img
              src={
                mainImgSrc !== ""
                  ? mainImgSrc
                  : product?.images[0]?.src || "/logo.png"
              }
              alt={product?.name || "product preview"}
              className="size-64"
            />

            <ProductCarousel
              images={product?.images || []}
              setImageOnClick={setImageOnClick}
            />
          </div>
          <div className="flex flex-col gap-5 w-full h-full">
            <h1 className="font-bold text-xl">
              {product?.name}
            </h1>

            <p className="line-clamp-2 w-full font-medium text-sm sm:text-md">
              {product?.description.slice(3, -5)}
            </p>

            <p className="line-clamp-3 w-full font-medium text-sm sm:text-md">
              {product?.short_description.slice(3, -5)}
            </p>

            <p className="font-bold">
              {product?.price}.00$
            </p>

            <Link
              to={`/product/${product?.id}/${product?.name}`}
              className="flex gap-1 justify-start items-start"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p className="hover:underline cursor-pointer text-neutral-400 text-[12px]">
                VIEW
              </p>
              <ExternalLinkIcon className="h-3 w-3" />
            </Link>
            <div className="flex gap-5 grow items-end">
              <AddToCart
                id={String(product?.id)}
                name={product?.name}
                categoryId={product?.categories[0]?.id}
                categoryName={product?.categories[0]?.name}
                quantity={"1"}
                preview
              />
              <Button
                variant={"outline"}
                className="rounded-none w-full"
                onClick={() =>
                  nav(
                    `/checkout/${product?.name}/${product?.id}/${product?.price}`
                  )
                }
              >
                BUY NOW
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
